// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id="loan-check-release" class="box">

  <sub-header header="\$ctrl.pageLabel"></sub-header>

    <form-section>

      <form name="\$ctrl.transactionForm">
        <table class="table">
          <tbody>
          <tr>
            <td>1.</td>
            <td>Check number:</td>
            <td>
              <input
                type="text"
                maxlength="32"
                ng-model="\$ctrl.checkNumber"
                ng-required="true"/>
            </td>
          </tr>
          <tr>
            <td>2.</td>
            <td>Total amount:</td>
            <td>
              <cash value="\$ctrl.loan.releaseAmount"
                ng-disabled="true"></cash>
            </td>
          </tr>
          </tbody>
        </table>

        <div class="labelled-field">
          <label>Remarks</label>
          <input type="text" ng-model="\$ctrl.remarks" required>
        </div>

        <div class="buttons">
          <button
            class="misc-transaction__cancel btn btn-warning"
            ng-click="\$ctrl.cancelChanges()">
            Cancel
          </button>
          <button
            type="submit"
            class="misc-transaction__save btn btn-success"
            ng-disabled="\$ctrl.transactionForm.\$invalid"
            ng-click="\$ctrl.save()">
            Create
          </button>
        </div>
      </form>
    </form-section>


</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/check-release/loan-check-release.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;